export function objectKeys<T, TKey extends keyof T>(value: T): TKey[] {
  return Object.keys(value).map(k => k as TKey);
}
